import { ThemeColors } from '~/themes/colors'

export interface AccountButtonColors {
  BackgroundColor: ThemeColors
  HoverBackgroundColor: ThemeColors
  ActiveBackgroundColor: ThemeColors
  TextColor: ThemeColors
  HoverTextColor: ThemeColors
}

export const accountButtonColors: AccountButtonColors = {
  BackgroundColor: {
    default: 'gray.400',
  },
  HoverBackgroundColor: {
    default: 'blue.200',
  },
  ActiveBackgroundColor: {
    default: 'blue.300',
  },
  TextColor: {
    default: 'gray.1300',
  },
  HoverTextColor: {
    default: 'blue.900',
  },
}
